const apps = [
    {
        icon: require("./images/stc/icon.webp"),
        title: "Staic",
        subtitle: "The daily stoic journal that writes back",
        description: "Staic is your  personal guide to living a more thoughtful, resilient life inspired by Stoic philosophy. Discover daily reflections, timeless wisdom from thinkers like Marcus Aurelius and Epictetus, and an AI-powered mentor to help personalize your introspection.",
        appstore: "https://apps.apple.com/us/app/id6742401808",
        url: "staic.app",
        screenshots: [
            require("./images/stc/1.webp"),
            require("./images/stc/2.webp"),
            require("./images/stc/3.webp"),
            require("./images/stc/4.webp"),
            require("./images/stc/5.webp"),
            require("./images/stc/6.webp"),
        ]
    },
    {
        icon: require("./images/job/icon.webp"),
        title: "Job Copilot",
        subtitle: "Master your next job interview with AI",
        description: "Interview Copilot helps job seekers prepare for their interviews by simulating real interview scenarios and providing personalized feedback. With AI-driven coaching, users can practice answers, improve their confidence, and fine-tune their performance for the best chances of landing their dream job.",
        appstore: "https://apps.apple.com/us/app/id6502905054",
        url: "jobcopilot.app",
        screenshots: [
           require("./images/job/1.webp"),
           require("./images/job/2.webp"),
           require("./images/job/3.webp"),
           require("./images/job/4.webp"),
           require("./images/job/5.webp"),
           require("./images/job/6.webp"),
           require("./images/job/7.webp"),
           require("./images/job/8.webp")
        ]
    },
    {
        icon: require("./images/est/icon.webp"),
        title: "Estimates Maker for Pro",
        subtitle: "Fast, professional estimates in minutes",
        description: "Estimate Maker for Pro simplifies the process of creating professional estimates for contractors, freelancers, and small businesses. Customize templates, add your branding, and generate detailed, accurate quotes for your clients—right from your device.",
        appstore: "https://apps.apple.com/us/app/id6754096344",
        screenshots: [
            require("./images/est/1.webp"),
            require("./images/est/2.webp"),
            require("./images/est/3.webp"),
            require("./images/est/4.webp"),
            require("./images/est/5.webp"),
            require("./images/est/6.webp"),
        ]
    },
    {
        icon: require("./images/cal/icon.webp"),
        title: "CaloSnap",
        subtitle: "Your personal AI nutrition coach",
        description: "CaloSnap leverages AI to create personalized meal plans, track calories, and monitor progress, ensuring you stay on top of your health goals. With CaloSnap, you can easily make informed dietary choices and optimize your eating habits for better health and well-being.",
        appstore: "https://apps.apple.com/us/app/id6529549531",
        screenshots: [
            require("./images/cal/1.webp"),
            require("./images/cal/2.webp"),
            require("./images/cal/3.webp"),
            require("./images/cal/4.webp"),
            require("./images/cal/5.webp"),
            require("./images/cal/6.webp"),
            require("./images/cal/7.webp")
        ]
    },
    {
        icon: require("./images/pil/icon.webp"),
        title: "Guided Pilates",
        subtitle: "Transform your body with Pilates routines",
        description: "Discover expertly guided Pilates sessions for all levels. Whether you are a beginner or advanced practitioner, Pilates offers tailored workouts that focus on core strength, flexibility, and mindfulness. Each session is designed to fit seamlessly into your lifestyle, helping you achieve your fitness goals efficiently.",
        appstore: "https://apps.apple.com/us/app/id6468663772",
        url: "getpilates.app",
        screenshots: [
            require("./images/pil/1.webp"),
            require("./images/pil/2.webp"),
            require("./images/pil/3.webp"),
            require("./images/pil/4.webp"),
            require("./images/pil/5.webp"),
            require("./images/pil/6.webp"),
            require("./images/pil/7.webp"),
            require("./images/pil/8.webp")
        ]
    },
    {
        icon: require("./images/wod/icon.webp"),
        title: "WOD Generator",
        subtitle: "Your personal CrossFit trainer",
        description: "WOD Generator offers a dynamic collection of high-intensity workouts designed to improve strength, endurance and overall fitness. Whether you're a beginner or an experienced athlete, generate customized workouts based on your goals and available equipment.",
        appstore: "https://apps.apple.com/us/app/id6670617154",
        screenshots: [
            require("./images/wod/1.webp"),
            require("./images/wod/2.webp"),
            require("./images/wod/3.webp"),
            require("./images/wod/4.webp"),
            require("./images/wod/5.webp"),
            require("./images/wod/6.webp"),
            require("./images/wod/7.webp")
        ]
    },
    {
        icon: require("./images/lyr/icon.webp"),
        title: "Dynamic Lyrics Widget",
        subtitle: "Display lyrics EVERYWHERE",
        description: "Bring your favorite song lyrics to your fingertips with the Dynamic Lyrics Widget. Seamlessly display and customize lyrics on your Home, Lock Screen and even your CarPlay, so you can sing along anytime and stay inspired by the music you love. Whether you're working, studying, or just relaxing, let the words flow with you everywhere you go.",
        appstore: "https://apps.apple.com/us/app/id6752877448",
        screenshots: [
            require("./images/lyr/1.webp"),
            require("./images/lyr/2.webp"),
            require("./images/lyr/3.webp"),
            require("./images/lyr/4.webp"),
            require("./images/lyr/5.webp")
        ]
    }
];

export default apps;